import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { MaterialModule } from '../module/material.module';
import { SharedPipesModule } from './shared-pipes.module';

import { MainNewsfeedComponent } from '../cockpit/main-news/news-newsfeed/news-newsfeed.component';
import { NewsCountComponent } from '../cockpit/main-news/news-newsfeed/news-count/news-count.component';
import { NewsFeedComponent } from '../cockpit/main-news/news-newsfeed/news-feed/news-feed.component';
import { NewsFeedListComponent } from '../cockpit/main-news/news-newsfeed/news-feed/news-feed-list/news-feed-list.component';
import { StoryViewComponent } from '../cockpit/main-news/news-newsfeed/news-feed/story-view/story-view.component';
import { BookmarkManagerComponent } from '../cockpit/main-news/news-newsfeed/news-feed/bookmark-manager/bookmark-manager.component';
import { ReportBoxComponent } from '../cockpit/main-news/report-box/report-box.component';
import { PortfolioEmptyStateComponent } from '../cockpit/main-news/news-portfolio/portfolio-empty-state/portfolio-empty-state.component';

/**
 * Components shared between the eager main-news area and lazy feature modules
 * (currently Scanner). A lazy module cannot see AppModule's flat declarations,
 * so the newsfeed subtree + report box live here; AppModule imports this so
 * the existing eager users keep working unchanged.
 */
@NgModule({
  declarations: [
    MainNewsfeedComponent,
    NewsCountComponent,
    NewsFeedComponent,
    NewsFeedListComponent,
    StoryViewComponent,
    BookmarkManagerComponent,
    ReportBoxComponent,
    PortfolioEmptyStateComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    InfiniteScrollModule,
    NgxChartsModule,
    SharedPipesModule,
  ],
  exports: [
    MainNewsfeedComponent,
    NewsCountComponent,
    NewsFeedComponent,
    ReportBoxComponent,
    PortfolioEmptyStateComponent,
  ],
})
export class SharedComponentsModule {}
